export default class NotesCtrl {

    constructor(R, $growl, $object) {
        "ngInject";
        this.$growl = $growl;

        this.$object = $object;
        this.data = R.copy(this.$object);
    }

    submit () {
        let self = this;
        this.data.patch({notes: this.data.notes}).then(
            (response) => {
                self.$object.notes = response.notes;
                self.$growl.success('Notes saved!');
            }
        );
    }
}



// WEBPACK FOOTER //
// ./src/app/common/notes.ctrl.js